import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withApp } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import { selectChapters, selectPages, selectNavigation } from './selectors'
// import { setProgress as setNavigationProgress } from '@brainstud/react-tbl/features/navigation/store/actions'

const withHome = Component => props => {
  const { dispatch, staticContext, ...rest } = props

  return <Component {...rest} />
}

const mapProps = (state, props) => {
  const user = state.account.user
  const chapters = selectChapters(state, props)
  const pages = selectPages(state, props)
  const navigation = selectNavigation(state, props, true)

  return { user, navigation, chapters, pages }
}

const mapActions = (dispatch) => {
  return {
    // setNavigationProgress: params => dispatch(setNavigationProgress(params)),
  }
}

export default compose(
  connect(mapProps, mapActions),
  withApp,
  withHome,
)

// import React from 'react'
// import ReactDOM from 'react-dom'
// import Routes from '@brainstud/react-tbl/themes/pgw/v1/routes'
// import { connect } from 'react-redux'
// import { config } from '../../../config'
// import { translate } from '@brainstud/react-tbl/themes/pgw/v1/translations'
// import { withApp, scrollTop, getItemById, getGreetHour } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
// import { AppView, AppHeader, AppContent, AppContainer } from '@brainstud/react-tbl/themes/pgw/v1/components/layout'
// import { Heading, Animation, Page, PageTitle } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
// import { bindActionCreators } from 'redux'
// import * as accountActions from '@brainstud/react-tbl/themes/pgw/v1/store/actions/accountActions'
// import NavigationCards from './components/NavigationCards'

// export default withApp(connect(
//   (state, props) => {
//     const user = state.account.user
//     const navigation = user.role === 'student'
//       ? Object.values(state.navigation.list.byId).filter(item => item.role !== 'coach')
//       : Object.values(state.navigation.list.byId)
//
//     // TODO fix progress
//     // const progress = state.account.user.role === 'student'
//     //   ? state.account.progress.filter(item => item.role !== 'coach')
//     //   : state.account.progress
//     const progress = []
//
//     // TODO fix lastProgress
//     // const lastProgress = state.account.user.role === 'student'
//     //   ? state.account.lastProgress.filter(item => item.role !== 'coach')
//     //   : state.account.lastProgress
//     const lastProgress = []
//
//     return {
//       user,
//       progress,
//       lastProgress,
//       navigation,
//       chapters: Object.values(state.chapters.chapters.byId),
//       pages: Object.values(state.pages.list.byId),
//     }
//   },
//   (dispatch) => ({
//     accountActions: bindActionCreators(accountActions, dispatch)
//   })
// )(HomeView))
